import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiResponse } from "../../models/api-response.model";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { map } from "rxjs/operators";
import { OrderCart, OrderItem } from "../_models/order";
import { environment } from "../../../../environments/environment";
import {HTTPRequestBuilder} from "../../../model/http.request.model";
import {HTTPMethod} from "../../../model/http-method.enum";
import {HTTPService} from "../../../service/http.service";
import {NotifyResellerDTO} from "../../../persistence/dto/NotifyResellerDTO";
import { Console } from "console";

export class CheckoutModel {
  order: OrderCart;
  otherTaxes: number;
  taxAndProfitAmount: number;
  subTotalAmount: number;
  totalAmount: number;
  barCode: String;
  resellerStamentBalance: number;
  orderCredit: number;
}

class AddItemResult {
  success: boolean;
  message: string;
  itemsCreated: OrderItem[];
  suggestedItems: OrderItem[];
}

@Injectable({
  providedIn: "root"
})
export class OrdersService {
  private API_ORDERS_URL = environment.API_URL + "api/orders";
  private API_ORDERS_SELECTED = environment.API_URL + "api/orders/exportSelected";
  private API_ORDERS_TRANSPORT_IMPORT = environment.API_URL + "api/users/files/route";
  private API_ORDERS_TRANSPORT_EXPORT = environment.API_URL + "api/users/files/route";
  private API_ORDER_PRODUCT = environment.API_URL + "api/Orders/item";
  private API_ORDER_NOSTOCK_PRODUCT = environment.API_URL + "api/Orders/nostock-item";
  private API_GET_CURRENTUSER_ORDERS = environment.API_URL + "api/users/current/orders";
  private API_CAMPAIGN_ORDERS_BY_USER_URL = environment.API_URL + "api/Orders/campaign/all";
  private API_CAMPAIGN_ORDERS_BY_USER2_URL = environment.API_URL + "api/Orders/campaign/all/2";
  private API_CURRENT_ORDER_FOR_CAMPAIGN = environment.API_URL + "api/Orders/campaign";
  private API_ORDERS_EXPORT_EXCEL = environment.API_URL + "api/Orders/exportOrders";
  private API_ORDERS_CORTADOS_EXPORT_EXCEL = environment.API_URL + "api/Orders/downloadCortados";
  private API_ORDERS_IMPORT_DETAILS = environment.API_URL + "api/Orders/importDetails"
  private API_ORDERS_IMPORT_DETAILS_TO_DELETE = environment.API_URL + "api/Orders/deleteDetails"


  constructor(private http: HttpClient, private fileService: FileService, private httpUtils: HttpUtilsService,
              private httpService: HTTPService) {}

  findOrders(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = this.API_ORDERS_URL + "/find";
    return this.http.post<QueryResultsModel>(url, queryParams, {
      headers: httpHeaders
    });
  }

  getOrder(id): Observable<any> {
    return this.http.get(this.API_ORDERS_URL + "/" + id);
  }

  getOrderById(id): Observable<OrderCart> {
    return this.http.get<OrderCart>(this.API_ORDERS_URL + "/" + id);
  }

  deleteOrder(id: any) {
    return this.http.delete<any>(`${this.API_ORDERS_URL}/${id}`);
  }

  cancelOrder(data) {
    const url = this.API_ORDERS_URL + "/statuscancelled";
    return this.http.post(url, data);
  }

  cancelNewOrFinishedOrder(orderId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.API_ORDERS_URL}/${orderId}/cancel`, {});
  }

  getCurrentOrderByUserId(userId): Observable<OrderCart> {
    if (userId != null) {
      return this.http.get<OrderCart>(this.API_CURRENT_ORDER_FOR_CAMPAIGN + "/" + userId);
    }
    return this.http.get<OrderCart>(this.API_CURRENT_ORDER_FOR_CAMPAIGN + "/");
  }

  getCampaignOrdersByUserId(userId): Observable<OrderCart[]> {
    if (userId != null) {
      return this.http.get<OrderCart[]>(this.API_CAMPAIGN_ORDERS_BY_USER_URL + "/" + userId);
    }
    return this.http.get<OrderCart[]>(this.API_CAMPAIGN_ORDERS_BY_USER_URL + "/");
  }

  getCampaignOrdersByUserName(userName): Observable<OrderCart[]> {
    if (userName != null) {
      return this.http.get<OrderCart[]>(this.API_CAMPAIGN_ORDERS_BY_USER2_URL + "/" + userName);
    }
    return this.http.get<OrderCart[]>(this.API_CAMPAIGN_ORDERS_BY_USER2_URL + "/");
  }

  createNewOrder(userId: string): Observable<OrderCart> {
    return this.http.post<OrderCart>(this.API_ORDERS_URL, { applicationUserId: userId });
  }

    deleteOrderItem(id: number, isNoStock: boolean, isNewQttyZero: boolean = false): Observable<any> {
        const params = new HttpParams().set('newQttyZero', isNewQttyZero.toString());
        console.log("paramas", params);
        return this.http.delete(this.API_ORDER_PRODUCT + "/" + id + "/" + isNoStock, { params });
    }

  updateReOrderItem(orderItemId, oldQuantity, newQuantity): Observable<any> {
      return this.http.patch(this.API_ORDERS_URL + "/item", {orderItemId, oldQuantity, newQuantity});
  }

  findCurrentUserOrders(query: QueryParamsModel): Observable<any> {
    return this.http.post(this.API_GET_CURRENTUSER_ORDERS, query);
  }

  doCheckout(orderId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.API_ORDERS_URL}/${orderId}/checkout`, {});
  }

  getCheckout(orderId: number): Observable<ApiResponse<CheckoutModel>> {
    return this.http.get<ApiResponse<CheckoutModel>>(`${this.API_ORDERS_URL}/${orderId}/checkout`)
      .pipe(
        map(res => res as ApiResponse<CheckoutModel>)
      );
  }

  addNewProduct(request): Observable<AddItemResult> {
    return this.http.post<AddItemResult>(this.API_ORDER_PRODUCT, request);
  }

  addNoStockProduct(request): Observable<AddItemResult> {
    return this.http.post<AddItemResult>(this.API_ORDER_NOSTOCK_PRODUCT, request);
  }

  dismissDebt(data) {
    const url = this.API_ORDERS_URL + "/statusreadyforinvoicing";
    return this.http.post(url, data);
  }

  exportExcel(data, url, method) {
    if (method === "get") {
      return this.http.get(url, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    } else {
      return this.http.post(url, data, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "application/vnd.ms-excel"
          });
        })
      );
    }
  }

  importOrdersTransport(element) {
    return this.fileService.fileUpload(element, this.API_ORDERS_TRANSPORT_IMPORT);
  }

  downloadOrdersTransport(data) {
    if (data.hasOwnProperty("transportId")) {
      let url = `${this.API_ORDERS_TRANSPORT_EXPORT}?campaignId=${data.campaignId}&Zone=${data.zone}&TransportId=${data.transportId}`;
      return this.exportExcel(data, url, "get");
    }
    let url = `${this.API_ORDERS_TRANSPORT_EXPORT}?campaignId=${data.campaignId}&Zone=${data.zone}`;
    return this.exportExcel(data, url, "get");
  }

  downloadSelectedOrders(data) {
    let url = this.API_ORDERS_SELECTED;
    return this.exportExcel(data, url, "post");
  }

  importOrderDetails(element){
    return this.fileService.fileUpload(element, this.API_ORDERS_IMPORT_DETAILS);
  }

  deleteOrderDetails(element){
    return this.fileService.fileUpload(element, this.API_ORDERS_IMPORT_DETAILS_TO_DELETE)
  }

  downloadAllOrdersDetails(data){
    let url = this.API_ORDERS_URL + "/exportOrderDetails";
    return this.exportExcel(data,url,"post");
  }

  downloadOrders(data){
    let url = this.API_ORDERS_EXPORT_EXCEL;
    return this.exportExcel(data,url,"post");
  }
  exportExcelCortados(data): Observable<any> {
    const url = `${this.API_ORDERS_CORTADOS_EXPORT_EXCEL}`;

    return this.http.post(url, data, { responseType: "blob" }).pipe(
      map((res) => {
        return new Blob([res], { type: "application/vnd.ms-excel" });
      })
    );
  }


    /**
     * @description
     *	Teniendo en cuenta la configuracion de aviso de monto de la campaña busca
     *  las revendedoras de la GZ con pedidos que superen dicho monto y las retorna con un resumen
     *  de su pedido
     */
    public getNotifyResellerOrders(): Observable<NotifyResellerDTO[]>{
        return this.httpService.send<typeof undefined, NotifyResellerDTO[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath("api/orders")
                .relativePath(`notify-reseller-orders`)
                .build())
    }
}
